import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIcon } from "@angular/material/icon";
import { Route, Router, RouterModule } from '@angular/router';
import { AuthService } from '../../service/auth.service';
import { AlertMessageComponent } from "../../shared/alert-message/alert-message.component";
import { AlertService } from '../../service/alert.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.css',
  imports: [MatIcon, RouterModule, ReactiveFormsModule, FormsModule, AlertMessageComponent, TranslateModule]
})
export class ForgotPasswordComponent {

  email : string;

  constructor(private router : Router,private authService : AuthService, private alertService: AlertService,
    private translate: TranslateService){
    this.email = "";
  }

  recoveryPassword() {

    if (!this.email || this.email.trim() === '') {
      this.alertService.errorKey('auth.errors.email-required');
      return;
    }

    // Basic email format validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(this.email.trim())) {
      this.alertService.errorKey('auth.errors.invalid-email');
      return;
    }

    this.authService.recoveryPassword(this.email).subscribe({next: () => {this.alertService.successKey('auth.forgot-password.success')},error: () => { this.alertService.errorKey('auth.errors.generic'); }});
  }

}

